import React from 'react'
import { TaskBoardType } from '../../types/task-board'

interface TaskBoardHeaderProps {
  board: TaskBoardType
}

export const TaskBoardHeader: React.FC<TaskBoardHeaderProps> = ({
  board
}) => {
  return (
    <div className='mb-4'>
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '1rem' }} />
    </div>
  )
}
